import { render, staticRenderFns } from "./AssistantDetail.vue?vue&type=template&id=4d5d9c43&"
import script from "./AssistantDetail.vue?vue&type=script&lang=js&"
export * from "./AssistantDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports